<h2 mat-dialog-title>SSL Certificate info</h2>
<p class="subtitle">{{ data.subTitle }}</p>
@if (aliases) {
  <p class="text">Aliases: {{ aliases }}</p>
}
<mat-dialog-content>
  <mat-checkbox [formControl]="autoRenew">Auto Renew - every 2.5 months</mat-checkbox>
  <mat-accordion togglePosition="before">
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title>SSL Certificate</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="item">
        <div class="label">
          <span>Certificate</span>
          <button
            class="button"
            [cdkCopyToClipboard]="certificate"
            (cdkCopyToClipboardCopied)="onCopied($event, 'Certificate')"
          >
            <fa-icon [icon]="['far', 'copy']" size="lg"></fa-icon>
          </button>
        </div>
        <div class="card">{{ certificate }}</div>
      </div>

      <div class="item">
        <div class="label">
          <span>Private key</span>
          <button
            class="button"
            [cdkCopyToClipboard]="key"
            (cdkCopyToClipboardCopied)="onCopied($event, 'Private key')"
          >
            <fa-icon [icon]="['far', 'copy']" size="lg"></fa-icon>
          </button>
        </div>
        <div class="card">{{ key }}</div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()">Save Changes</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
